export default __webpack_public_path__ + "static/media/marmore.dd241b62.png";